import { Component, OnInit, DoCheck } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-backoffice-legal',
    templateUrl: './backoffice-legal.component.html',
    styleUrls: ['./backoffice-legal.component.css']
})
export class BackofficeLegalComponent implements OnInit, DoCheck {
    show: boolean;

    constructor(private router: Router) {}

    ngDoCheck() {
        if (window.location.href.match('.backoffice/legal$')) {
            this.show = true;
        } else {
            this.show = false;
        }
    }

    ngOnInit() {}

    showPanel() {
        return this.show;
    }

    goto(route) {
        this.show = false;
        this.router.navigate([route]);
    }
}
